import { IconProps } from '../types';

const DownArrowSmall = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="M17.1263 19.1212C16.5228 19.7863 15.4775 19.7863 14.8741 19.1212L11.0642 14.9219C10.1777 13.9448 10.871 12.3797 12.1903 12.3797L19.81 12.3797C21.1293 12.3797 21.8226 13.9448 20.9361 14.9219L17.1263 19.1212Z" />
  </svg>
);

export default DownArrowSmall;
